import * as echarts from "echarts";
import { EleResize } from "./a.js";
import zhanjiangMP from "@/assets/get/china.json";
import _ from "lodash";
import router from "@/router/index";
import i18n from "@/i18n";

/* 行业统计 */
const industryStatisticsEcharts = (options) => {
  let { chartDom, dataList, xData, dataType } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  let option = {
    title: {
      show: false,
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      left: "0%",
      top: 0,
      icon: "circle",
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: 14,
        fontWeight: "normal",
        color: "#FFFFFF",
      },
      data: dataType,
      selectedMode: "single",
      selected: {
        [dataType[0]]: true,
        [dataType[1]]: false,
        [dataType[2]]: false,
      },
    },
    grid: {
      top: "20%",
      right: "5%",
      bottom: "5%",
      left: "0%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      axisTick: {
        show: false,
      },
      axisLabel: {
        interval: 0,
        textStyle: {
          fontSize: 14,
          fontWeight: 400,
          color: "#FFFFFF",
          padding: [0, 0, 0, 0],
        },
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#294462",
          opacity: 0.3,
        },
      },
      data: xData,
    },
    yAxis: {
      type: "value",
      minInterval: 5,
      name: "",
      nameTextStyle: {
        fontSize: 12,

        color: "#ffffff",
        padding: [0, 0, 0, 10],
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#06304C",
        },
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,

          fontWeight: "normal",
          color: "#FFFFFF",
          padding: [0, 0, 0, 0],
        },
      },
    },
    dataZoom: [
      {
        // x轴没有具体的数值
        type: "inside", // 图形内部的滚动条
        xAxisIndex: [0], // 明确指定滚动的轴
        minValueSpan: 1, // x轴最小的index
        maxValueSpan: 5, // x轴最大的index
        zoomOnMouseWheel: false, // 关闭鼠标滚轮缩放
      },
    ],
    series: [
      {
        name: dataType[0],
        type: "bar",
        barWidth: 10,
        barGap: "80%",
        itemStyle: {
          borderWidth: 1,
          borderRadius: [5, 5, 5, 5],
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#11EFFD", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "#21D2F9", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "#3CC1EE", // 100% 处的颜色
              },
            ],
          },
        },
        data: [
          (dataList["device"] && dataList["device"]["化工"]) || 0,
          (dataList["device"] && dataList["device"]["油气"]) || 0,
          (dataList["device"] && dataList["device"]["造纸"]) || 0,
          (dataList["device"] && dataList["device"]["电力"]) || 0,
          (dataList["device"] && dataList["device"]["核电"]) || 0,
          (dataList["device"] && dataList["device"]["通用"]) || 0,
        ],
      },
      {
        name: dataType[1],
        type: "bar",
        barWidth: 10,
        barGap: "80%",
        itemStyle: {
          borderWidth: 1,
          borderRadius: [5, 5, 5, 5],
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#59EDC9", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "#2DAF91", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "#1D9275", // 100% 处的颜色
              },
            ],
          },
        },
        data: [
          (dataList["order"] && dataList["order"]["化工"]) || 0,
          (dataList["order"] && dataList["order"]["油气"]) || 0,
          (dataList["order"] && dataList["order"]["造纸"]) || 0,
          (dataList["order"] && dataList["order"]["电力"]) || 0,
          (dataList["order"] && dataList["order"]["核电"]) || 0,
          (dataList["order"] && dataList["order"]["通用"]) || 0,
        ],
      },
      {
        name: dataType[2],
        type: "bar",
        barWidth: 10,
        barGap: "80%",
        itemStyle: {
          borderWidth: 1,
          borderRadius: [5, 5, 5, 5],
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#F3E139", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "#F3E139", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "#90883F", // 100% 处的颜色
              },
            ],
          },
        },
        data: [
          (dataList["customer"] && dataList["customer"]["化工"]) || 0,
          (dataList["customer"] && dataList["customer"]["油气"]) || 0,
          dataList["customer"] && dataList["customer"]["造纸" || 0],
          (dataList["customer"] && dataList["customer"]["电力"]) || 0,
          (dataList["customer"] && dataList["customer"]["核电"]) || 0,
          (dataList["customer"] && dataList["customer"]["通用"]) || 0,
        ],
      },
    ],
  };

  var app = {
    currentIndex: -1,
  };
  var changePieInterval = setInterval(selectPie, 2000);
  function selectPie() {
    var dataLen = option.series[0].data.length;
    const data = option.legend.data;
    // 取消之前高亮的图形
    myChart.dispatchAction({
      type: "downplay",
      seriesIndex: 0,
      dataIndex: app.currentIndex,
    });
    // myChart.dispatchAction({
    //     type: 'legendUnSelect',
    //     // 图例名称
    //     name: data[app.currentIndex]
    // })
    app.currentIndex = (app.currentIndex + 1) % dataLen;
    //console.log(app.currentIndex);
    // 高亮当前图形
    myChart.dispatchAction({
      type: "highlight",
      seriesIndex: 0,
      dataIndex: app.currentIndex,
    });
    myChart.dispatchAction({
      type: "legendToggleSelect",
      name: data[app.currentIndex],
    });
  }
  myChart.on("mouseover", (params) => {
    // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
    clearInterval(changePieInterval);
    app.currentIndex = params.dataIndex;
  });

  myChart.on("mouseout", () => {
    // 用户鼠标移出时，重新开始自动切换
    if (changePieInterval) clearInterval(changePieInterval);
    changePieInterval = setInterval(selectPie, 2000);
  });

  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
const deviceStatusEcharts = (options) => {
  let { chartDom, dataLot, title, unit } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  let colors = [
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#6463D6",
      },
      {
        offset: 0.5,
        color: "#434289",
      },
      {
        offset: 1,
        color: "#7373E1",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#11EFFD",
      },
      {
        offset: 0.5,
        color: "#3FB5CF",
      },
      {
        offset: 1,
        color: "#3CC1EE",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#59EDC9",
      },
      {
        offset: 0.5,
        color: "#2DAF91",
      },
      {
        offset: 1,
        color: "#1D9275",
      },
    ]),
  ];
  // let textColors = [
  //     "#6463D6",
  //     "#11EFFD",
  //     "#1D9275",
  //     "#1D9275"
  // ]
  let datas = dataLot;
  let option = {
    title: [
      {
        text: title + unit,
        x: "center",
        y: "center",
        textStyle: {
          fontSize: 20,
          fontWeight: "bolder",
          color: "#fff",
        },
      },
    ],
    tooltip: {
      trigger: "item",
      // formatter: "{b}：\n{d}%",
      formatter: (params) => {
        let per = "";
        if (params.dataIndex == 1) {
          //iot connected 不展示
          per = params.name;
        } else {
          per = `${params.name}: ${((params.value / title) * 100).toFixed(2)}%`;
        }
        return per;
      },
    },
    series: [
      {
        type: "pie",
        center: ["50%", "50%"],
        radius: ["45%", "85%"],
        startAngle: 180,
        itemStyle: {
          color: (params) => {
            return colors[params.dataIndex];
          },
          // shadowBlur: this.getFontSize(30),
          // shadowColor: "rgba(255, 255, 255, 0.3)",
        },
        // label: {
        //     show: true,
        //     formatter: (params) => {
        //         console.log(params)
        //         let color = "white";
        //         let showText = `${params.name}`;
        //         if (params.dataIndex === 0) {
        //             color = "white";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 1) {
        //             color = "white1";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 2) {
        //             color = "white2";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 3) {
        //             color = "white3";
        //             showText = `{${color}|${params.name}}`;
        //         }
        //         const circle =
        //             "hr" +
        //             color.slice(0, 1).toUpperCase() +
        //             color.slice(1).toLowerCase();
        //         return `${showText}\n{${circle}|}\n{${color}|${params.percent}%(${params.value}${unit})}`;
        //     },
        //     color: "#fff",
        //     fontSize: 24,
        //     lineHeight: 20,

        //     rich: {
        //         white: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white1: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white2: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white3: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         hrWhite: {
        //             backgroundColor: textColors[0],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite1: {
        //             backgroundColor: textColors[1],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite2: {
        //             backgroundColor: textColors[2],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite3: {
        //             backgroundColor: textColors[3],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //     },
        // },
        // labelLine: {
        //     length: 40,
        //     length2: 80,
        //     lineStyle: {
        //         color:'#ffffff',
        //         width: 1,
        //     },
        // },
        label: {
          alignTo: "edge",
          // formatter: '{name|{b}}\n{time|{d}}%({time|{c}})'+unit,
          formatter: (params) => {
            let per = "";
            if (params.dataIndex == 1) {
              per =
                `(${params.value})` +
                i18n.global.t('overview_static.common["台"]');
            } else {
              per =
                ((params.value / title) * 100).toFixed(2) +
                `%(${params.value})` +
                i18n.global.t('overview_static.common["台"]');
            }
            return `${params.name}\n${per}`;
          },
          minMargin: 5,
          edgeDistance: 10,
          color: "#fff",
          lineHeight: 15,
          rich: {
            time: {
              fontSize: 10,
              color: "#ffffff",
            },
          },
        },
        labelLine: {
          length: 15,
          length2: 0,
          maxSurfaceAngle: 80,
        },

        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2;
          const points = params.labelLinePoints;
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width;
          return {
            labelLinePoints: points,
          };
        },
        data: datas,
        z: 0,
      },
    ],
  };
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
function leftSlide(params) {
  router.push("/fullIndex?path=4&id=" + params);
  // var box = document.getElementById('areaName')
  // var htmlText = ''
  // var arr = [
  //     'IMP004', 'B0610613',
  //     'B0610613', 'B0610613',
  //     'B0610613', 'B0610613',
  //     'B0610613', 'B0610613',
  // ]
  // arr.map(item => {
  //     htmlText += ('<div style="display:flex;justify-content:space-between;align-items:center;width:50%;margin-top:5px"><div style="margin-left:5px;width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#FFFFFF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);"></div>' + item + '</div>')
  // })
  // box.innerHTML = '<div style="margin-left:15px;margin-top:10px;font-size:20px;margin-bottom:10px">' + params + '</div><div style="width:200px;display:flex;flex-wrap: wrap;padding-left:20px;margin-top:10px">' + htmlText + '</div><div style="text-align:end;width:200px;margin-top10px"><i style="color:#FFFFFFA6;cursor: pointer;">返回</i></div>'
}
window.leftSlide = leftSlide;
const chinaEcharts = (options, callback) => {
  // var vbgPatternImg = document.createElement("img");
  // vbgPatternImg.style.height = vbgPatternImg.height = vbgPatternImg.width = vbgPatternImg.style.width = "100%";
  // vbgPatternImg.src =require('./卫星地图蒙版.png');
  let {
    chartDom,
    dataList,
    name,
    type,
    inRange,
    max,
    min,
    popUpMessage,
    pBobj,
  } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  //各省份的地图json文件
  var provinces = {
    上海: require("../assets/get/area/上海.json"),
    河北: require("../assets/get/area/河北.json"),
    山西: require("../assets/get/area/山西.json"),
    内蒙古: require("../assets/get/area/内蒙古.json"),
    辽宁: require("../assets/get/area/辽宁.json"),
    吉林: require("../assets/get/area/吉林.json"),
    黑龙江: require("../assets/get/area/黑龙江.json"),
    江苏: require("../assets/get/area/江苏.json"),
    浙江: require("../assets/get/area/浙江.json"),
    安徽: require("../assets/get/area/安徽.json"),
    福建: require("../assets/get/area/福建.json"),
    江西: require("../assets/get/area/江西.json"),
    山东: require("../assets/get/area/山东.json"),
    河南: require("../assets/get/area/河南.json"),
    湖北: require("../assets/get/area/湖北.json"),
    湖南: require("../assets/get/area/湖南.json"),
    广东: require("../assets/get/area/广东.json"),
    广西: require("../assets/get/area/广西.json"),
    海南: require("../assets/get/area/海南.json"),
    四川: require("../assets/get/area/四川.json"),
    贵州: require("../assets/get/area/贵州.json"),
    云南: require("../assets/get/area/云南.json"),
    西藏: require("../assets/get/area/西藏.json"),
    陕西: require("../assets/get/area/陕西.json"),
    甘肃: require("../assets/get/area/甘肃.json"),
    青海: require("../assets/get/area/青海.json"),
    宁夏: require("../assets/get/area/宁夏.json"),
    新疆: require("../assets/get/area/新疆.json"),
    北京: require("../assets/get/area/北京.json"),
    天津: require("../assets/get/area/天津.json"),
    重庆: require("../assets/get/area/重庆.json"),
    香港: require("../assets/get/area/香港.json"),
    澳门: require("../assets/get/area/澳门.json"),
  };
  var sAllData = [];
  var allData = [
    { name: "北京", value: 10, address: ["116.3979471", "39.9081726"] },

    { name: "上海", value: 30, address: ["121.4692688", "31.2381763"] },

    { name: "天津", value: 10, address: ["117.2523808", "39.1038561"] },

    { name: "重庆", value: 50, address: ["106.548425", "29.5549144"] },

    { name: "河北", value: 100, address: ["114.4897766", "38.0451279"] },

    { name: "山西", value: 40, address: ["112.5223053", "37.8357424"] },

    { name: "辽宁", value: 1, address: ["123.4116821", "41.7966156"] },

    { name: "吉林", value: 1, address: ["125.3154297", "43.8925629"] },

    { name: "黑龙江", value: 1, address: ["126.6433411", "45.7414932"] },

    { name: "浙江", value: 1, address: ["120.1592484", "30.265995"] },

    { name: "福建", value: 1, address: ["119.2978134", "26.0785904"] },

    { name: "山东", value: 1, address: ["117.0056", "36.6670723"] },

    { name: "河南", value: 1, address: ["113.6500473", "34.7570343"] },

    { name: "湖北", value: 1, address: ["114.2919388", "30.5675144"] },

    { name: "湖南", value: 1, address: ["112.9812698", "28.2008247"] },

    { name: "广东", value: 1, address: ["113.2614288", "23.1189117"] },

    { name: "海南", value: 1, address: ["110.3465118", "20.0317936"] },

    { name: "四川", value: 1, address: ["104.0817566", "30.6610565"] },

    { name: "贵州", value: 1, address: ["106.7113724", "26.5768738"] },

    { name: "云南", value: 1, address: ["102.704567", "25.0438442"] },

    { name: "江西", value: 1, address: ["115.8999176", "28.6759911"] },

    { name: "陕西", value: 1, address: ["108.949028", "34.2616844"] },

    { name: "青海", value: 1, address: ["101.7874527", "36.6094475"] },

    { name: "甘肃", value: 1, address: ["103.7500534", "36.0680389"] },

    { name: "广西", value: 1, address: ["108.3117676", "22.8065434"] },

    { name: "新疆", value: 1, address: ["87.6061172", "43.7909393"] },

    { name: "内蒙古", value: 1, address: ["111.6632996", "40.8209419"] },

    { name: "西藏", value: 1, address: ["91.1320496", "29.657589"] },

    { name: "宁夏", value: 1, address: ["106.2719421", "38.4680099"] },

    { name: "台湾", value: 1, address: ["120.9581316", "23.8516062"] },

    { name: "香港", value: 1, address: ["114.139452", "22.391577"] },

    { name: "澳门", value: 1, address: ["113.5678411", "22.167654"] },

    { name: "安徽", value: 1, address: ["117.2757034", "31.8632545"] },

    { name: "江苏", value: 1, address: ["118.7727814", "32.0476151"] },
  ];
  var mapList = [];
  var convertData = function (data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      // var geoCoord = provinces[data[i].name] && provinces[data[i].name]['features'] && provinces[data[i].name]['features'][0]['properties']['center'];
      console.log(data[i]);
      if(data[i].name === "NEV演示客户"){
        data[i].address = ["117.84","36.53"]
      }
      var geoCoord = data[i].address;
      var colorArea = "#CCEDFF";
      if (
        data[i].value>0&&(data[i].name === "新疆" ||
        data[i].name === "浙江" ||
        data[i].name === "新疆宜化化工有限公司" ||
        data[i].name === "合盛电业（鄯善）有限公司" ||
        data[i].name === "海盐县城乡污水处理厂" ||
        data[i].name === "中泰矿业电厂"|| data[i].name === "山东"|| data[i].name === "NEV演示客户")
      ) {


        colorArea = "#5df36f";
      }
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
          itemStyle: {
            normal: {
              color: colorArea,
            },
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.RadialGradient(
                0,
                1,
                1,
                1,
                "#CBEDFF70",
                "#CBEDFF"
              ),
              borderColor: "#FFFFFF",
              borderWidth: 2,
              borderType: "solid",
              borderDashOffset: 10,
              borderCap: "butt",
              borderJoin: "bevel",
              borderMiterLimit: 10,
              shadowBlur: 10,
              shadowColor: "#FFFFFF7E",
              // shadowOffsetX: 10 ,
              // shadowOffsetY: 10 ,
            },
          },
        });
      }
    }
    return res;
  };

  if (name == "china") {
    loadMap(zhanjiangMP, "china");
  } else {
    loadMap(provinces[name], name);
  } //初始化全国地图

  var timeFn = null;

  //单击切换到省级地图，当mapCode有值,说明可以切换到下级地图
  myChart.on("click", function (params) {
    console.log(params);
    clearTimeout(timeFn);
    //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
    timeFn = setTimeout(function () {
      var name = params.name; //地区name
      var mapCode = provinces[name]; //地区的json数据
      if (!mapCode) {
        return;
      }
      mapList = [];
      callback(params);
      loadMap(mapCode, name, params.color);
    }, 250);
  });

  // 绑定双击事件，返回全国地图
  // myChart.on('dblclick', function () {
  //     //当双击事件发生时，清除单击事件，仅响应双击事件
  //     clearTimeout(timeFn);
  //     //返回全国地图

  //         callback()

  //     // loadMap(zhanjiangMP, 'china');
  // });

  /**
     获取对应的json地图数据，然后向echarts注册该区域的地图，最后加载地图信息
     @params {String} mapCode:json数据的地址
     @params {String} name: 地图名称
     */
  // function randomRange(min, max) { // min最小值，max最大值

  //     return Math.floor(Math.random() * (max - min)) + min;

  // }
  function loadMap(mapCode, name) {
    if (name == "china") {
      var list = dataList["map"] || dataList;
      allData.map((item) => {
        for (let i in list) {
          if (name == "china") {
            if (i.includes(item.name)) {
              if (type == "iot") {
                item.value = list[i]["total"] || 0;
                mapList.push(item);
              } else if (type == "work") {
                item.value = list[i]["order_total"] || 0;
                mapList.push(item);
              } else if (type == "load") {
                item.value =
                  (list[i] == "-" || list[i] == "NA" ? 0 : list[i]) || 0;
                mapList.push(item);
              } else {
                item.value =
                  (list[i]["已绑定"] || 0) +
                  (list[i]["报废"] || 0) +
                  (list[i]["未绑定"] || 0);
                mapList.push(item);
              }
            }
          } else {
            if (i.includes(name)) {
              item.value =
                (dataList["map"][i]["已绑定"] || 0) +
                (dataList["map"][i]["报废"] || 0) +
                (dataList["map"][i]["未绑定"] || 0);
              mapList.push(item);
            }
          }
        }
      });
      mapList = convertData(mapList);
    } else {
      //             features
      // properties
      mapCode &&
        mapCode.features.map((item, index) => {
          sAllData.push({
            name: item.properties.name,
            address: item.properties.center,
            value: 0,
          });
          for (let i in dataList["map"]) {
            if (
              i.includes(item.properties.name) ||
              i == "重庆市" ||
              i == "上海市" ||
              i == "北京市" ||
              i == "天津市"
            ) {
              var num = 0;
              for (var j in dataList["map"][i]) {
                num +=
                  (dataList["map"][i][j]["已绑定"] || 0) +
                  (dataList["map"][i][j]["报废"] || 0) +
                  (dataList["map"][i][j]["未绑定"] || 0);
                //   ||item.geometry.coordinates[0][0][randomRange(0,item.geometry.coordinates[0][0].length-1)]
                var obj = {
                  name: j,
                  address:
                    (dataList["map"][i][j].extra.coordinate &&
                      dataList["map"][i][j].extra.coordinate) ||
                    [],
                  value:
                    (dataList["map"][i][j]["已绑定"] || 0) +
                    (dataList["map"][i][j]["报废"] || 0) +
                    (dataList["map"][i][j]["未绑定"] || 0),
                };
                mapList.push(obj);
              }
              sAllData[index].value = num;
            }
          }
        });
      console.log(mapList);
      mapList = convertData(mapList);
    }
    echarts.registerMap(name, mapCode);
    var option = {
      // backgroundColor: {
      //     image: vbgPatternImg,
      //     repeat: 'repeat',
      // },
      // graphic: [
      //     {
      //         type: 'image', // 图形元素类型
      //         id: 'logo', // 更新或删除图形元素时指定更新哪个图形元素，如果不需要用可以忽略。
      //         right: 'center', // 根据父元素进行定位 (居中)
      //         bottom: '0%', // 根据父元素进行定位   (0%), 如果bottom的值是 0，也可以删除该bottom属性值。
      //         z: 0,  // 层叠
      //         bounding: 'all', // 决定此图形元素在定位时，对自身的包围盒计算方式
      //         style: {
      //             image: './廓形.png', // 这里一定要注意、注意，必须是https开头的图片路径地址
      //             width: 970,
      //             height:760
      //         }
      //     }
      // ],
      tooltip: {
        show: true,
        padding: 0,
        triggerOn: "mousemove",
        enterable: name == "china" ? false : true,
        alwaysShowContent: false,
        position: function (point) {
          // 固定在顶部
          var list = {
            setting: 230,
            iot: 200,
            work: 180,
            load: 120,
          };
          return [point[0] - 60, point[1] - list[type]];
        },
        backgroundColor: "#FFFFFF00",
        borderColor: "#FFFFFF00",
        renderMode: "html",
        formatter: function (params) {
          if(params.seriesName!=='china'&&params.componentIndex===0){
            return;
          }
          var mapData = "";
          var list = dataList["map"] || dataList;
          for (let i in list) {
            if (name != "china") {
              if (type == "load") {
                mapData = list[i];
              } else {
                for (var j in list[i]) {
                  if (j.includes(params.name)) {
                    mapData = list[i][j];
                  }
                }
              }
            } else {
              if (i.includes(params.name)) {
                mapData = list[i];
              }
            }
          }

          if (params.data && mapData && type == "setting") {
            return (
              `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:${
                      name == "china" ? "260px" : "220px"
                    };width:300px;top:0;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require("./dasd.png")} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${i18n.global.t(params.name)}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: linear-gradient(210deg, #59EDC9 0%, #2DAF91 53.65%, #1D9275 93.75%);box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.setting["已绑定"]}</div>
                       <div> ${mapData["已绑定"]}${
                popUpMessage.unit["台"]
              }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#EDDD81;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.setting["未绑定"]}</div>
                       <div> ${mapData["未绑定"]}${
                popUpMessage.unit["台"]
              }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#54C0DF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.setting["报废"]}</div>
                       <div> ${mapData["报废"]}${popUpMessage.unit["台"]}</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#59EDC9;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${
                         name == "china"
                           ? popUpMessage.setting["工单总量"]
                           : popUpMessage.setting["进行中工单总量"]
                       }</div>
                       <div>${
                         name == "china"
                           ? mapData["工单总量"]
                           : mapData["进行中工单总量"]
                       }${popUpMessage.unit["单"]}</div>
                       </div>
                       ` +
              (name == "china"
                ? `<div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#59EDC9;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.setting["商机总量"]}</div>
                       <div>${mapData["商机总量"]}${popUpMessage.unit["单"]}</div>
                       </div><div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#B156E5;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.setting["客户总量"]}</div>
                       <div> ${mapData["客户总量"]}${popUpMessage.unit["个"]}</div>
                       </div>`
                : `
                       <div style='text-align:end;width:240px'>
                       <i style='color:#FFFFFFA6;cursor: pointer;'  onclick='leftSlide("${mapData.id}")'>${i18n.global.t('查看设备')}</i>
                       </div>`) +
              `
                    </div>
                    </div>`
            );
          }
          if (params.data && mapData && type == "iot") {
            return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:180px;width:300px;top:0;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require("./dasd.png")} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${i18n.global.t(params.name)}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: linear-gradient(210deg, #59EDC9 0%, #2DAF91 53.65%, #1D9275 93.75%);box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       IoT Ready</div>
                       <div> ${mapData["iot_ready"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#EDDD81;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       IoT Connected</div>
                       <div> ${mapData["iot_connected"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#54C0DF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.iot["非IoT 设备"]}</div>
                       <div> ${mapData["non-iot"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                    </div>
                    </div>`;
          }
          if (params.data && mapData && type == "work") {
            return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:200px;width:300px;top:0;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require("./dasd.png")} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${i18n.global.t(params.name)}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: linear-gradient(210deg, #59EDC9 0%, #2DAF91 53.65%, #116496 93.75%);box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.work["工单总量"]}</div>
                       <div> ${mapData["order_total"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#EFE376;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.work["进行中工单总量"]}</div>
                       <div> ${mapData["progress_total"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#FE7979;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.work["完成工单总量"]}</div>
                       <div> ${mapData["complete_total"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                       <div style='width:230px' class='ms-3 mt-1 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#C2E6FF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.work["商机总量"]}</div>
                       <div> ${mapData["bo_totail"]}${
              popUpMessage.unit["台"]
            }</div>
                       </div>
                    </div>
                    </div>`;
          }
          if (params.data && mapData && type == "load") {
            return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:100px;width:300px;top:0px;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require("./dasd.png")} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${i18n.global.t(params.name)}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: #CCEDFF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       ${popUpMessage.load["工单负荷量"]}</div>
                       <div> ${mapData}%</div>
                       </div>
                       
                    </div>
                    </div>`;
          }
        },
      },
      toolbox: {
        left: 10,
        top: "20%",
        feature: {
          myBack: {
            show: type == "setting" ? true : false,
            title: "返回",
            icon: "path://M473.2 276.9v-133c-4-18.4-11.7-27-20.2-30.3-17.2-6.7-37.8 8.5-37.8 8.5L95.9 395.4c-70.1 48.4-4.8 84.7-4.8 84.7L405.5 751c62.9 46 67.7-24.2 67.7-24.2V603.4c319.3-99.2 449.9 297.5 449.9 297.5 12.1 21.8 19.3 0 19.3 0 123.4-595-469.2-624-469.2-624z m0 0",
            iconStyle: {
              color: "#1aaef6",
              borderColor: "#1aaef6",
            },
            onclick: function () {
              sAllData = [];
              loadMap(zhanjiangMP, "china");
            },
          },
        },
      },
      visualMap: {
        min: min,
        max: max,
        left: 40,
        bottom: 200,
        calculable: false,
        text: [pBobj[type] + "\n\n" + max, min],
        inRange: inRange,
        textStyle: {
          color: "#ffffff",
          fontSize: 14,
        },
      },
      geo: [
        {
          // 主图
          map: name,
          top: "6.4%",
          zlevel: 1,
          zoom: 1.02, //当前视角的缩放比例
          roam: false, //是否开启平游或缩放
          show: true,
          tooltip: {
            show: false
        },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              show: false,
              borderColor: "#0A70B7",
              borderWidth: 1,
              areaColor: "#0A619E",
            },
            emphasis: {
              show: false,
              areaColor: "#2AB8FF00",
              borderWidth: 0,
              borderColor: "#6DCEFF",
            },
          },
        },
        //第一层投影
        {
          map: name,
          top: "6.3%",
          zlevel: 2,
          zoom: 1.03, //当前视角的缩放比例
          roam: false, //是否开启平游或缩放
          show: true,
          tooltip: {
            show: false
        },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              show: false,
              borderJoin: "round",
              borderColor: "#0A70B7",
              borderWidth: 1,
              areaColor: "#094875",
            },
            emphasis: {
              show: false,
              areaColor: "#2AB8FF00",
              borderWidth: 0,
              borderColor: "#6DCEFF",
            },
          },
        },
        // 第二层投影
        {
          map: name,
          top: "6.1%",
          zlevel: 3,
          // zoom: 1, //当前视角的缩放比例
          roam: false, //是否开启平游或缩放
          show: true,
        
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            
            normal: {
              show: false,
              borderJoin: "round",
              borderColor: "#9FD7FF",
              areaColor: "#22366CCC",
              borderWidth: name == "china" ? 12 : 12,
            },
            emphasis: {
              show: false,
            },
          },
        },
        {
          map: name,
          top: "6.1%",
          zlevel: 4,
          // zoom: 1, //当前视角的缩放比例
          roam: false, //是否开启平游或缩放
          show: true,
        
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 1, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              show: false,
              borderJoin: "round",
              borderColor: "#0A70B7",
              borderWidth: 1,
              areaColor: "#094875",
            },
            emphasis: {
              show: false,
              areaColor: "#094875",
              borderWidth: 0,
              borderColor: "#6DCEFF",
            },
          },
        },

        // option = {backgroundColor: '#000',//画布背景颜色geo: {show: true,map: 'china',label: {show: false},roam: false,itemStyle: {normal: {areaColor: '#000',borderWidth: 4, //设置外层边框borderColor:'#f8911b',},emphasis: {show: false,// areaColor: '#01215c'}}},series: [{type: 'map',map: 'china',label: {show: false},roam: false,itemStyle: {normal: {areaColor: '#000',borderColor: '#a18a3a',borderWidth: 1},emphasis: {show: false,areaColor: null}},}]
      ],

      series: [
        {
          name: name,
          type: "map",
          // zoom: 1, //当前视角的缩放比例
          geoIndex: 3,
          top: "6.1%",
          mapType: name,
          hoverAnimation: false,
          selectedMode: "false", //是否允许选中多个区域
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },

          //地图区域的多边形 图形样式
          itemStyle: {
            normal: {
              borderColor: "#2ab8ff",
              borderWidth: 2,
              areaColor: "#22366CCC",
              // borderWidth:2,
              // shadowBlur:2,
              // shadowColor:'#0e2f50',
              // shadowOffsetX:5,
              // shadowOffsetY:10,
            },
            emphasis: {
              areaColor: "#28365C",
              borderWidth: 0,
              borderColor: "#6DCEFF",
            },
          },
          //     itemStyle: {
          //         normal: {

          //             areaColor: {
          //                 image: vbgPatternImg, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
          //                 repeat: 'repeat' // 是否平铺, 可以是 'repeat-x', 'repeat-y', 'no-repeat'
          //               },
          //         }

          // },
          data: sAllData.length > 0 ? sAllData : allData,
          // markPoint: {
          //     symbol: 'image://' + require('../assets/images/dashboard/locationPinned.png'),
          //     data: [{ valueIndex: 3}],
          //     symbolOffset: [17, -23],
          //     zlevel: 3,
          //     label: {
          //         position: ['35%', '20%'],
          //         color: '#ffffff'
          //     }
          // },
        },
        {
          type: "scatter",
          coordinateSystem: "geo",
          geoIndex: 3,
          symbolSize: 20,
          label: {
            normal: {
              show: true,
              offset: [0, -20],
              formatter: function (value) {
                return value.value[2] + (type == "load" && "%");
              },
              textStyle: {
                color: "#fff",
                fontSize: 13,
                fontWeight: 600,
              },
            },
          },
          zlevel: 6,
          symbol: "circle",
          colorBy: "data",

          data: mapList,
        },
        // 柱状体的顶部
        // {
        //     type: 'scatter',
        //     coordinateSystem: 'geo',
        //     geoIndex: 0,
        //     zlevel: 5,
        //     label: {
        //       show: true,
        //       formatter: function () {
        //         return `顶部label`
        //       },
        //       position: "top"
        //     },
        //     symbol: 'circle',
        //     symbolSize: [20, 10],
        //     itemStyle: {
        //       color: 'rgb(22,255,255, 1)',
        //       opacity: 1
        //     },
        //     silent: true,
        //     data: mapList
        // },
        //   // 柱状体的底部
      ],
    };
    console.log(option);
    myChart && option && myChart.setOption(option);
    // curMap = {
    //     mapCode: mapCode,
    //     mapName: name
    // };
  }
  // myChart.on('georoam', (params) => {
  //     let myOption = myChart.getOption()
  //     if (params.zoom != null) {
  //       //捕捉到缩放时
  //       myOption.geo.slice(1).forEach((geo) => {
  //         geo.zoom = myOption.geo[3].zoom
  //         geo.center = myOption.geo[3].center
  //       })
  //     } else {
  //       //捕捉到拖曳时
  //       myOption.geo.slice(1).forEach((geo) => {
  //         geo.center = myOption.geo[3].center
  //       })
  //     }
  //     myChart && myOption && myChart.setOption(myOption);
  //   })
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
};
const otherStatesEcharts = (options) => {
  let { chartDom, dataList, legendData, unit } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  // let chartData = [
  //     {
  //         name: '已绑定',
  //         value: 50,
  //         color: '#33A087',
  //         radius: ['48%', '64%'],
  //     },
  //     {
  //         name: '未绑定',
  //         value: 50,
  //         color: '#F0DD73',
  //         radius: ['48%', '64%'],

  //     },

  //     {
  //         name: '报废',
  //         value: 20,
  //         color: '#5471BD',
  //         radius: ['64%', '80%'],
  //     },
  // ];
  // let sum = chartData.reduce((pre, cur) => pre + cur.value, 0);

  var pattern2 = new RegExp("[A-Za-z]+");
  let option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {d}%",
    },
    legend: {
      orient: "vertical",
      left: "50%",
      top: "center",
      icon: "circle",
      data: legendData,
      formatter: function (name) {
        return name + "\n" + dataList[name] + unit;
      },
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: pattern2.test(legendData[0].name) ? 14 : 15,
        fontWeight: "normal",
        color: "#FFFFFF",
      },
    },

    series: [
      {
        type: "pie",
        clockWise: false,
        hoverAnimation: false,
        radius: ["48%", "64%"],
        center: ["25%", "50%"],
        label: {
          // 设置图形标签样式
          show: false, // 未高亮时不显示标签，否则高亮时显示的标签会与静态的标签重叠
          position: "center",
          color: "#ffffff",
          // 设置标签展示内容,其中{d}、{b}为echarts标签内容格式器
          formatter: "{d_style|{d}}{per_style|%}\n{b_style|{b}}",
          // 为标签内容指定样式，只能设置series-pie.label支持的样式
          rich: {
            d_style: {
              fontSize: 24,
            },
            per_style: {
              fontSize: 18,
            },
            b_style: {
              fontSize: 14,
            },
          },
        },
        itemStyle: {
          normal: {
            borderRadius: 0,
          },
        },
        emphasis: {
          // 设置高亮时显示标签
          label: {
            show: true,
          },
          scale: true, // 设置高亮时放大图形
          scaleSize: 5,
        },
        color: ["#33A087", "#F0DD73", "#5471BD"],
        data: [
          {
            value: dataList[legendData[0].name],
            name: legendData[0].name,
            itemStyle: {
              color: "#33A087",
            },
          },
          {
            value: dataList[legendData[1].name],
            name: legendData[1].name,
            itemStyle: {
              color: "#F0DD73",
            },
          },
        ],
      },
      {
        name: "",
        type: "pie",
        clockWise: false,
        hoverAnimation: false,
        radius: ["64%", "80%"],
        center: ["25%", "50%"],
        label: {
          // 设置图形标签样式
          show: false, // 未高亮时不显示标签，否则高亮时显示的标签会与静态的标签重叠
          // position: 'center',
          // color: '#ffffff',
          // // 设置标签展示内容,其中{d}、{b}为echarts标签内容格式器
          // formatter: '{d_style|{d}}{per_style|%}\n{b_style|{b}}',
          // // 为标签内容指定样式，只能设置series-pie.label支持的样式
          // rich: {
          //     d_style: {
          //         fontSize: 28
          //     },
          //     per_style: {
          //         fontSize: 20
          //     },
          //     b_style: {
          //         fontSize: 14
          //     }
          // }
        },

        color: ["#A7B1B2CC", "#5471BD"],

        data: [
          {
            value:
              dataList[legendData[0].name] +
              dataList[legendData[1].name] +
              dataList[legendData[2].name],
            name: "",
            itemStyle: {
              color: "#A7B1B2CC",
              normal: {
                borderRadius: 0,
              },
            },
          },
          {
            value: dataList[legendData[2].name],
            name: legendData[2].name,
            itemStyle: {
              color: "#5471BD",
              normal: {
                borderRadius: 0,
              },
            },
          },
        ],
      },
    ],
  };
  /*********************** 饼图轮播相关 ***********************/
  let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
  let changePieInterval = setInterval(selectPie, 3000); // 设置自动切换高亮图形的定时器

  function highlightPie() {
    // 取消所有高亮并高亮当前图形
    for (let optIdx in option.series) {
      let opt = option.series[optIdx].data;
      if (opt.length < 2)
        // 外圈(只有一条数据)
        continue;

      // 遍历饼图数据，取消所有图形的高亮效果, 高亮当前图形
      for (let idx in opt)
        myChart.dispatchAction({
          type: idx != currentIndex ? "downplay" : "highlight",
          seriesIndex: optIdx,
          dataIndex: idx,
        });
    }
  }

  myChart.on("mouseover", (params) => {
    // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
    clearInterval(changePieInterval);
    currentIndex = params.dataIndex;
    highlightPie();
  });

  myChart.on("mouseout", () => {
    // 用户鼠标移出时，重新开始自动切换
    if (changePieInterval) clearInterval(changePieInterval);
    changePieInterval = setInterval(selectPie, 3000);
  });

  function selectPie() {
    // 高亮效果切换到下一个图形
    var dataLen = legendData.length;
    currentIndex = (currentIndex + 1) % dataLen;
    highlightPie();
  }
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
const productTypeEcharts = (options) => {
  let { chartDom, dataList, legendData, unit, valueList } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });

  const chartColorList = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: "#11EDFDDD",
      },
      {
        offset: 0.5,
        color: " #3FB5CF",
      },
      {
        offset: 1,
        color: "#3CC1EE77",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: "#59EDC9",
      },
      {
        offset: 0.5,
        color: " #2DAF91",
      },
      {
        offset: 1,
        color: "#1D9275",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: "#FFEA2E",
      },
      {
        offset: 0.5,
        color: " #F3E139",
      },
      {
        offset: 1,
        color: "#BFB23D",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: "#6463D6",
      },
      {
        offset: 0.5,
        color: " #434289",
      },
      {
        offset: 1,
        color: "#7373E1",
      },
    ]),
  ].reverse();
  // 饼图测试数据
  let testData = dataList;

  // 由于这套饼图中除了“大饼”外的饼图构造非常相似(只有“大饼”高亮时显示中间的标签)
  // 可以用一个数组存储其中不相同的配置，然后遍历配置数组自动生成所有serie

  let serieList = [];
  serieList.push({
    name: "大饼",
    z: 10, // 放在最上层
    type: "pie",
    radius: ["56%", "73%"], // 通过设置内径与外径将饼图变为圆环饼图
    center: ["27%", "50%"],
    itemStyle: {
      borderRadius: 5, // 设置圆环的圆角弧度
    },
    emphasis: {
      // 设置高亮时显示标签
      label: {
        show: true,
      },
      scale: true, // 设置高亮时放大图形
      scaleSize: 10,
    },
    label: {
      // 设置图形标签样式
      show: false, // 未高亮时不显示标签，否则高亮时显示的标签会与静态的标签重叠
      position: "center",
      color: "#ffffff",
      // 设置标签展示内容,其中{d}、{b}为echarts标签内容格式器
      formatter: "{d_style|{d}}{per_style|%}\n{b_style|{b}}",
      // 为标签内容指定样式，只能设置series-pie.label支持的样式
      rich: {
        d_style: {
          fontSize: 28,
        },
        per_style: {
          fontSize: 20,
        },
        b_style: {
          fontSize: 14,
        },
      },
    },
    data: testData,
  });

  var pattern2 = new RegExp("[A-Za-z]+");

  var legends = legendData;
  let option = {
    color: chartColorList, // 设置饼图全局配色
    tooltip: {
      trigger: "item",
      formatter: "{b}: {d}%",
    },
    legend: {
      orient: "vertical",
      left: "50%",
      top: "center",
      icon: "circle",
      itemWidth: 8,
      itemHeight: 8,
      formatter: function (name) {
        return name + "\n" + valueList[name] + unit;
      },
      textStyle: {
        fontSize: pattern2.test(legendData[0]) ? 14 : 15,

        fontWeight: 400,
        color: "#FFFFFF",
      },
      data: legends,
    },
    series: [
      ...serieList,
      {
        name: "外边框",
        type: "pie",
        clockWise: true, //顺时加载
        hoverAnimation: false, //鼠标移入变大
        center: ["27%", "50%"],
        radius: ["87%", "89%"],
        label: {
          normal: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
        data: [
          {
            value: 10,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0)",
            },
          },
          {
            value: 90,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0.3)",
            },
          },
        ],
      },
      {
        name: "外边框",
        type: "pie",
        clockWise: true, //顺时加载
        hoverAnimation: false, //鼠标移入变大
        center: ["27%", "50%"],
        radius: ["92%", "93%"],
        startAngle: 180,
        label: {
          normal: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
        data: [
          {
            value: 10,
            name: "",
            itemStyle: {
              color: "#1FC6FF8F",
            },
          },
          {
            value: 90,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0.3)",
            },
          },
        ],
      },
    ],
  };
  console.log(option); // 可以打印出具体的option便于理解其结构

  /*********************** 饼图轮播相关 ***********************/
  let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
  let changePieInterval = setInterval(selectPie, 3000); // 设置自动切换高亮图形的定时器

  function highlightPie() {
    // 取消所有高亮并高亮当前图形
    for (let optIdx in option.series) {
      let opt = option.series[optIdx].data;
      if (opt.length < 2)
        // 外圈(只有一条数据)
        continue;

      // 遍历饼图数据，取消所有图形的高亮效果, 高亮当前图形
      for (let idx in opt)
        myChart.dispatchAction({
          type: idx != currentIndex ? "downplay" : "highlight",
          seriesIndex: optIdx,
          dataIndex: idx,
        });
    }
  }

  myChart.on("mouseover", (params) => {
    // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
    clearInterval(changePieInterval);
    currentIndex = params.dataIndex;
    highlightPie();
  });

  myChart.on("mouseout", () => {
    // 用户鼠标移出时，重新开始自动切换
    if (changePieInterval) clearInterval(changePieInterval);
    changePieInterval = setInterval(selectPie, 3000);
  });

  function selectPie() {
    // 高亮效果切换到下一个图形
    var dataLen = testData.length;
    currentIndex = (currentIndex + 1) % dataLen;
    highlightPie();
  }
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};

/* 半圆型仪表盘 */
const outputBagsChart = (options) => {
  let { chartDom, dataList, valueList, unit, title } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  var data = valueList;
  //这里才是关键整去掉下半部分的关键，
  //计算data中value的总和
  var a = 0;
  for (var i = 0; i < data.length; i++) {
    a += data[i].value;
  }
  //添加新的元素到data中，并设置其颜色样式为白色
  data.push({
    value: a == 0 ? 1 : a,
    name: "",
    radius: ["50%", "90%"],
    center: ["50%", "75%"],
    startAngle: 180,
    itemStyle: {
      normal: {
        color: "rgba(0,0,0,0)",
      },
    },
  });
  // let textColors = ['#2DAF91', '#7373E1']

  let option = {
    tooltip: {
      show: false,
      trigger: "item",
      padding: 0,
      backgroundColor: "#FFFFFF00",
      borderColor: "#FFFFFF00",
      renderMode: "html",
      position: function () {
        // 固定在顶部
        return [-130, 50];
      },
      formatter: function () {
        // var mapData = ''
        // for (let i in dataList['map']) {
        //     if (i.includes(params.name)) {
        //         mapData = dataList['map'][i]
        //     }
        // }

        // if (params.data && mapData)
        return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                <div class='position-absolute' style="width:140px;top:0;left:0px;">
                
                <img style='width:100%;height:100%' src=${require("./dasd.svg")} />
                </div>
                <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:10px;left:10px;color:#FFFFFF'>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   1.</div>
                   <div> 黑龙江 4单</div>
                   </div>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   2.</div>
                   <div> 广西  4单</div>
                   </div>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   3.</div>
                   <div> 四川  4单</div>
                   </div>
                </div>
                </div>`;
      },
    },
    title: [
      {
        text: title,
        right: "center",
        bottom: "30%",
        textStyle: {
          color: "#F77474",
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: 15,
        },
      },
      {
        text: _.get(dataList, ["delay"], "0") + unit,
        right: "center",
        bottom: "20%",
        textStyle: {
          color: "#F77474",
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: 15,
        },
      },
    ],
    series: [
      {
        // name:'访问来源',
        type: "pie",
        hoverAnimation: false,
        radius: ["50%", "90%"],
        center: ["51%", "75%"],
        startAngle: 180,
        // avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 2,
          shadowColor: "rgba(0, 0, 0, 0.25)",
          shadowOffsetX: 2,
          shadowOffsetY: 3,
        },
        // labelLine: {
        //     length: 30,
        //     length2: 90,
        //     lineStyle: {
        //         color:'#ffffff',
        //         width: 1,
        //     },
        // },
        // label: {
        //     show: true,
        //     formatter: (params) => {
        //         let color = "white";
        //         let showText = `${params.name}`;
        //         if (params.dataIndex === 0) {
        //             color = "white";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 1) {
        //             color = "white1";
        //             showText = `{${color}|${params.name}}`;
        //         }
        //         const circle =
        //             "hr" +
        //             color.slice(0, 1).toUpperCase() +
        //             color.slice(1).toLowerCase();
        //         if (params.name) return `${showText}\n{${circle}|}\n{${color}|${_.get(dataList, ['transform'])}% (${params.value}${unit})}`;
        //     },
        //     color: "#fff",
        //     fontSize: 24,
        //     lineHeight: 20,

        //     rich: {
        //         white: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -80, 0, -80],
        //         },
        //         white1: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         hrWhite: {
        //             backgroundColor: textColors[0],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite1: {
        //             backgroundColor: textColors[1],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //     },
        // },
        label: {
          alignTo: "edge",
          formatter: "{name|{b}}\n{time|{d}}%({time|{c}})",
          minMargin: 5,
          edgeDistance: 10,
          color: "#fff",
          lineHeight: 15,
          rich: {
            time: {
              fontSize: 10,
              color: "#ffffff",
            },
          },
        },
        labelLine: {
          length: 15,
          length2: 0,
          maxSurfaceAngle: 80,
        },
        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2;
          const points = params.labelLinePoints;
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width;
          return {
            labelLinePoints: points,
          };
        },
        color: ["#2DAF91", "#7373E1"],
        data: data,
      },
    ],
  };
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
const opportunityEcharts = (options) => {
  let { chartDom, dataList } = options;

  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  let colors = [
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#6463D6",
      },
      {
        offset: 0.5,
        color: "#434289",
      },
      {
        offset: 1,
        color: "#7373E1",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#11EFFD",
      },
      {
        offset: 0.5,
        color: "#3FB5CF",
      },
      {
        offset: 1,
        color: "#3CC1EE",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#59EDC9",
      },
      {
        offset: 0.5,
        color: "#2DAF91",
      },
      {
        offset: 1,
        color: "#1D9275",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#FFEA2E",
      },
      {
        offset: 0.5,
        color: "#F3E139",
      },
      {
        offset: 1,
        color: "#BFB23D",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#7AA3CC",
      },
      {
        offset: 0.5,
        color: "#5A77A1",
      },
      {
        offset: 1,
        color: "#3C5268",
      },
    ]),
    new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      {
        offset: 0,
        color: "#6FBC7A",
      },
      {
        offset: 0.5,
        color: "#499854",
      },
      {
        offset: 1,
        color: "#94F2A1",
      },
    ]),
  ];
  // let textColors = [
  //     "#6463D6",
  //     "#11EFFD",
  //     "#2DAF91",
  //     "#F3E139",
  //     "#5A77A1",
  //     "#499854"
  // ]

  let option = {
    tooltip: {
      show: false,
      trigger: "item",
      padding: 0,
      backgroundColor: "#FFFFFF00",
      borderColor: "#FFFFFF00",
      renderMode: "html",
      position: function () {
        // 固定在顶部
        return [-130, 50];
      },
      formatter: function () {
        // var mapData = ''
        // for (let i in dataList['map']) {
        //     if (i.includes(params.name)) {
        //         mapData = dataList['map'][i]
        //     }
        // }

        // if (params.data && mapData)
        return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                <div class='position-absolute' style="width:140px;top:0;left:0px;">
                
                <img style='width:100%;height:100%' src=${require("./dasd.svg")} />
                </div>
                <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:10px;left:10px;color:#FFFFFF'>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   1.</div>
                   <div> 黑龙江 4单</div>
                   </div>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   2.</div>
                   <div> 广西  4单</div>
                   </div>
                   <div style='width:100%' class='ms-3 mt-1 d-flex justify-content-between'>
                   <div  class='d-flex align-items-center fs-13'>
                   3.</div>
                   <div> 四川  4单</div>
                   </div>
                </div>
                </div>`;
      },
    },
    series: [
      {
        type: "pie",
        center: ["50%", "50%"],
        radius: ["45%", "85%"],
        itemStyle: {
          color: (params) => {
            return colors[params.dataIndex];
          },
          // shadowBlur: this.getFontSize(30),
          // shadowColor: "rgba(255, 255, 255, 0.3)",
        },
        // label: {
        //     show: true,
        //     formatter: (params) => {
        //         let color = "white";
        //         let showText = `${params.name}`;
        //         if (params.dataIndex === 0) {
        //             color = "white";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 1) {
        //             color = "white1";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 2) {
        //             color = "white2";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 3) {
        //             color = "white3";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 4) {
        //             color = "white4";
        //             showText = `{${color}|${params.name}}`;
        //         } else if (params.dataIndex === 5) {
        //             color = "white5";
        //             showText = `{${color}|${params.name}}`;
        //         }
        //         const circle =
        //             "hr" +
        //             color.slice(0, 1).toUpperCase() +
        //             color.slice(1).toLowerCase();
        //         return `${showText}\n{${circle}|}\n{${color}|${params.value}% (${params.value}${unit})}`;
        //     },
        //     color: "#fff",
        //     fontSize: 24,
        //     lineHeight: 20,

        //     rich: {
        //         white: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white1: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white2: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white3: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white4: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         white5: {
        //             color: "white",
        //             fontSize: 15,
        //             padding: [3, -100, 0, -100],
        //         },
        //         hrWhite: {
        //             backgroundColor: textColors[0],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite1: {
        //             backgroundColor: textColors[1],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite2: {
        //             backgroundColor: textColors[2],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite3: {
        //             backgroundColor: textColors[3],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite4: {
        //             backgroundColor: textColors[4],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //         hrWhite5: {
        //             backgroundColor: textColors[5],
        //             borderRadius: 3,
        //             width: 3,
        //             height: 3,
        //             padding: [3, 3, 0, -12],
        //         },
        //     },
        // },
        // labelLine: {
        //     length: 30,
        //     length2: 90,
        //     lineStyle: {
        //         color:'#ffffff',
        //         width: 1,
        //     },
        // },
        label: {
          alignTo: "edge",
          formatter: "{name|{b}}\n{time|{d}}%({time|{c}})",
          minMargin: 5,
          edgeDistance: 10,
          color: "#fff",
          lineHeight: 15,
          rich: {
            time: {
              fontSize: 10,
              color: "#ffffff",
            },
          },
        },
        labelLine: {
          length: 15,
          length2: 0,
          maxSurfaceAngle: 80,
        },

        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2;
          const points = params.labelLinePoints;
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width;
          return {
            labelLinePoints: points,
          };
        },
        data: dataList,
        z: 0,
      },
    ],
  };
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
const pieEcharts = (options) => {
  let { chartDom, dataList, title, color } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });
  let option = {
    title: [
      {
        text: dataList + "%",
        top: "20%",

        right: "center",
        textStyle: {
          color: "#FFFFFF",
          fontSize: 15,
          fontWeight: "400",
        },
      },
      {
        text: title,
        top: "47%",

        right: "center",
        textStyle: {
          color: "#FFFFFF",
          fontSize: 12,
          fontWeight: "400",
        },
      },
    ],
    legend: { show: false },
    series: [
      {
        name: "",
        type: "pie",
        radius: ["0%", "87%"],
        hoverAnimation: false,
        color: color,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: [100],
      },
      {
        type: "pie",
        radius: ["92%", "100%"],
        hoverAnimation: false,
        labelLine: {
          show: false,
        },
        color: ["#00000000"],
        data: [
          {
            value: dataList,
            name: "",
            percent: "20%",
            itemStyle: {
              color: color,
            },
          },
          { value: 80 },
        ],
      },
    ],
  };
  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
const equipmentMaintenanceEcharts = (options) => {
  let { chartDom, wData, valueData, legendData1, legendData2, unit } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: "svg" });

  const chartColorList = [
    "#14ACC1",
    "#59EDC9",
    "#30B495",
    "#30B495CC",
    "#30B49580",
    "#FEE92C",
    "#5471BD",
    "#874594",
  ];
  // 饼图测试数据
  let testData = valueData;

  // 由于这套饼图中除了“大饼”外的饼图构造非常相似(只有“大饼”高亮时显示中间的标签)
  // 可以用一个数组存储其中不相同的配置，然后遍历配置数组自动生成所有serie
  const pieSeriesSettings = [
    {
      name: "内部小饼", // 饼图名称
      radius: ["56%", "70%"], // 饼图内径/外径尺寸
      opacity: 1, // 普通状态下的透明度
      empyOpacity: 1, // 高亮状态下的透明度
      scaleSize: 1, // 高亮状态下图形放大的尺寸
      isBorder: false, // 是否是外圈(外圈只有一条数据，否则与“大饼”数据相同)
    },
  ];
  let serieList = [];
  serieList.push({
    name: "大饼",
    z: 10, // 放在最上层
    type: "pie",
    radius: ["75%", "80%"], // 通过设置内径与外径将饼图变为圆环饼图
    opacity: 0.8, // 普通状态下的透明度

    itemStyle: {
      borderRadius: 2, // 设置圆环的圆角弧度
    },
    emphasis: {
      // 设置高亮时显示标签
      label: {
        show: true,
      },
      itemStyle: {
        opacity: 1, // 设置高亮状态下圆环的透明度
      },
      scale: true, // 设置高亮时放大图形
      scaleSize: 5,
    },
    label: {
      // 设置图形标签样式
      show: false, // 未高亮时不显示标签，否则高亮时显示的标签会与静态的标签重叠
      position: "center",
      color: "#ffffff",
      // 设置标签展示内容,其中{d}、{b}为echarts标签内容格式器
      formatter: "{d_style|{d}}{per_style|%}\n{b_style|{b}}",
      // 为标签内容指定样式，只能设置series-pie.label支持的样式
      rich: {
        d_style: {
          fontSize: 24,
        },
        per_style: {
          fontSize: 18,
        },
        b_style: {
          fontSize: 12,
        },
      },
    },
    data: testData,
  });
  for (let pieSetting of pieSeriesSettings) {
    serieList.push({
      name: pieSetting.name,
      z: 1, // 放在最下层
      type: "pie",
      radius: pieSetting.radius, // 通过设置内径与外径将饼图变为圆环饼图
      itemStyle: {
        color: pieSetting.isBorder ? "#fff" : null,
        borderRadius: 2, // 设置圆环的圆角弧度
        opacity: pieSetting.opacity, // 设置普通状态下圆环的透明度
      },
      emphasis: {
        // 设置高亮时不显示标签
        disabled: pieSetting.isBorder, // 外圈需关闭高亮效果
        itemStyle: {
          opacity: pieSetting.empyOpacity, // 设置高亮状态下圆环的透明度
        },
        label: {
          show: false,
        },
        scale: !pieSetting.isBorder, // 外圈需关闭高亮放大效果
        scaleSize: pieSetting.scaleSize,
      },
      label: {
        // 设置图形标签样式
        show: false, // 未高亮时不显示标签，否则高亮时显示的标签会与静态的标签重叠
      },
      data: pieSetting.isBorder ? [{ value: 1, name: "border" }] : wData,
    });
  }

  let option = {
    color: chartColorList, // 设置饼图全局配色
    tooltip: {
      trigger: "item",
      formatter: "{b}: {d}%",
    },
    legend: [
      {
        icon: "circle",
        selectedMode: true,
        left: "0%",
        orient: "vertical",
        top: "15%",
        data: legendData1,
        formatter: function (name) {
          var num = "";
          valueData.map((item) => {
            if (item.name == name) {
              num = item.value;
            }
          });
          return name + "\n" + num + unit;
        },
        itemWidth: 8,
        itemHeight: 8,
        padding: 5,
        itemGap: 6,
        textStyle: {
          color: "rgba(233, 240, 255, 1)",
          fontSize: 14,
        },
      },
      {
        icon: "circle",
        selectedMode: true,
        right: "0%",
        top: "15%",
        orient: "vertical",
        itemWidth: 8,
        itemHeight: 8,
        padding: 5,
        itemGap: 6,
        data: legendData2,
        formatter: function (name) {
          var num = "";
          valueData.map((item) => {
            if (item.name == name) {
              num = item.value;
            }
          });
          return name + "\n" + num + unit;
        },
        textStyle: {
          color: "rgba(233, 240, 255, 1)",
          fontSize: 14,
        },
      },
    ],
    series: [
      ...serieList,
      {
        name: "外边框",
        type: "pie",
        clockWise: true, //顺时加载
        hoverAnimation: false, //鼠标移入变大
        center: ["50%", "50%"],
        radius: ["90%", "92%"],
        label: {
          normal: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
        data: [
          {
            value: 10,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0)",
            },
          },
          {
            value: 90,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0.3)",
            },
          },
        ],
      },
      {
        name: "外边框",
        type: "pie",
        clockWise: true, //顺时加载
        hoverAnimation: false, //鼠标移入变大
        center: ["50%", "50%"],
        radius: ["97%", "99%"],
        startAngle: 180,
        label: {
          normal: {
            show: false,
          },
        },
        tooltip: {
          show: false,
        },
        data: [
          {
            value: 10,
            name: "",
            itemStyle: {
              color: "#1FC6FF8F",
            },
          },
          {
            value: 90,
            name: "",
            itemStyle: {
              color: "rgba(30,80,148,0.3)",
            },
          },
        ],
      },
    ],
  };
  console.log(option); // 可以打印出具体的option便于理解其结构

  /*********************** 饼图轮播相关 ***********************/
  let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
  let changePieInterval = setInterval(selectPie, 3000); // 设置自动切换高亮图形的定时器

  function highlightPie() {
    // 取消所有高亮并高亮当前图形
    for (let optIdx in option.series) {
      let opt = option.series[optIdx].data;
      if (opt.length < 2)
        // 外圈(只有一条数据)
        continue;

      // 遍历饼图数据，取消所有图形的高亮效果, 高亮当前图形
      for (let idx in opt)
        myChart.dispatchAction({
          type: idx != currentIndex ? "downplay" : "highlight",
          seriesIndex: optIdx,
          dataIndex: idx,
        });
    }
  }

  myChart.on("mouseover", (params) => {
    // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
    clearInterval(changePieInterval);
    currentIndex = params.dataIndex;
    highlightPie();
  });

  myChart.on("mouseout", () => {
    // 用户鼠标移出时，重新开始自动切换
    if (changePieInterval) clearInterval(changePieInterval);
    changePieInterval = setInterval(selectPie, 3000);
  });

  function selectPie() {
    // 高亮效果切换到下一个图形
    var dataLen = testData.length;
    currentIndex = (currentIndex + 1) % dataLen;
    highlightPie();
  }

  var listener = () => {
    myChart.resize();
  };
  EleResize.on(chartDom, listener);
  myChart.clear();
  myChart && option && myChart.setOption(option);
};
export {
  industryStatisticsEcharts,
  deviceStatusEcharts,
  chinaEcharts,
  otherStatesEcharts,
  productTypeEcharts,
  outputBagsChart,
  opportunityEcharts,
  pieEcharts,
  equipmentMaintenanceEcharts,
};
